const translations = {
  "en": {
    "Download": "Download",
    "Download completed": "Download completed",
    "Download started": "Download started",
    "Failed to load attachment": "Failed to load attachment",
    "Please update the app to access files": "Please update the app to access files"
  },
  "zh-tw": {
    "Download": "下載",
    "Download completed": "下載已完成",
    "Download started": "下載已開始",
    "Failed to load attachment": "無法載入附件",
    "Please update the app to access files": "請更新 App 以存取檔案"
  }
};

export default translations;
